import {t} from '../../../common/getTranslations';
import {ErrorArea} from '../ErrorArea/ErrorArea';
import {SubtabAgeRestrictErrorProps} from './SubtabAgeRestrictErrorProps.interface';
import {SubtabAgeRestrictErrorType} from './SubtabAgeRestrictErrorType.enum';

export function SubtabAgeRestrictError({
  isMobile,
  type,
  ...props
}: SubtabAgeRestrictErrorProps) {
  return (
    <>
      {type === SubtabAgeRestrictErrorType.BeforeLogin &&
        'onClickLogin' in props && (
          <ErrorArea isMobile={isMobile}>
            <ErrorArea.Title>
              {t('mainhome_age_verification_popup_title')}
            </ErrorArea.Title>
            <ErrorArea.MainText>
              {t('viewer_adult_verification')}
            </ErrorArea.MainText>
            <ErrorArea.LabelButton onClick={props.onClickLogin}>
              {t('common_login')}
            </ErrorArea.LabelButton>
          </ErrorArea>
        )}
      {type === SubtabAgeRestrictErrorType.NotAuthenticatedUser &&
        'onClickProcessAuth' in props && (
          <ErrorArea isMobile={isMobile}>
            <ErrorArea.Title>
              {t('mainhome_age_verification_popup_title')}
            </ErrorArea.Title>
            <ErrorArea.MainText>
              {t('mainhome_age_verification_popup_desc')}
            </ErrorArea.MainText>
            <ErrorArea.LabelButton onClick={props.onClickProcessAuth}>
              {t('mainhome_age_verification_popup_button')}
            </ErrorArea.LabelButton>
          </ErrorArea>
        )}
      {type === SubtabAgeRestrictErrorType.Under19 && (
        <ErrorArea isMobile={isMobile}>
          <ErrorArea.Title>
            {t('mainhome_age_verification_error_popup_title')}
          </ErrorArea.Title>
          <ErrorArea.MainText>
            {t('mainhome_age_verification_error_popup_desc')}
          </ErrorArea.MainText>
        </ErrorArea>
      )}
    </>
  );
}
